import React from "react";
import { Navigate } from "react-router-dom";

import BasicTwosVerify from '../pages/AuthenticationInner/TwoStepVerification/BasicTwosVerify';
import BasicPasswCreate from "../pages/AuthenticationInner/PasswordCreate/BasicPasswCreate";

// Authentication
import Login from "../pages/Authentication/Login";
import ForgetPasswordPage from "../pages/Authentication/ForgetPassword";
import Logout from "../pages/Authentication/Logout";
import ChangePass from "../pages/AuthenticationInner/PasswordReset/ChangePass";
import EmailVerify from "../pages/Authentication/EmailVerify";

import Chat from "../pages/Chat";
import DocumentList from "../pages/Documets";

const authProtectedRoutes = [
  {
    path: "/",
    exact: true,
    component: <Chat />,
  },
  { path: "*", component: <Navigate to="/" /> },
  
  // Dashboard
  { path: "/documents", component: <DocumentList /> },
  
  // Authentication
  { path: "/verify-email", component: <EmailVerify /> },
  { path: "/change-password", component: <ChangePass /> },
];


const publicRoutes = [
  // Authentication Pages
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
  { path: "/forgot-password", component: <ForgetPasswordPage /> },
  { path: "/twostep-verification", component: <BasicTwosVerify /> },
  { path: "/reset-password", component: <BasicPasswCreate /> },
];

export { authProtectedRoutes, publicRoutes };